import type { ProgramEventType } from 'models';
import { useCallback } from 'react';
import { usePermissions } from 'permissions';

export const useCreateGeneralProgramEventPermissions = () => {
  const { canCreateConferenceEvent, canCreateWebinarEvent, canRequestTelehealthEvent } = usePermissions();

  return useCallback(() => {
    const createEventAllowedTypes: ProgramEventType[] = [
      ...(canCreateWebinarEvent({}) ? (['webinar'] satisfies ProgramEventType[]) : []),
      ...(canCreateConferenceEvent({}) ? (['conference'] satisfies ProgramEventType[]) : []),
    ];

    return {
      createEventAllowedTypes,
      isCreateButtonAvailable: createEventAllowedTypes.length > 0,
      isTelehealthButtonAvailable: canRequestTelehealthEvent({}),
    };
  }, [canCreateWebinarEvent, canCreateConferenceEvent, canRequestTelehealthEvent]);
};
